/* eslint-disable no-nested-ternary */
/* eslint-disable radix */
/* eslint-disable no-unneeded-ternary */
import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
import React, { useState } from 'react';
import { Link as RouterLink, createSearchParams, useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
// material
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Autocomplete,
  Avatar,
  Badge,
  Box,
  Button,
  Card,
  Checkbox,
  Chip,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  IconButton,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
// components
import {
  collection,
  deleteDoc,
  doc,
  getCountFromServer,
  getDoc,
  getDocs,
  orderBy,
  query,
  where,
} from 'firebase/firestore';

import { deepOrange } from '@mui/material/colors';
import { db } from '../../../../firebase.config';
import Iconify from '../../../../components/Iconify';
import { UserAuth } from '../../../../context/AuthContext';
import { Variables } from '../../../../context/VariableContext';
import CustomButton from '../../../../components/CustomButton';

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

export default function FilterCommDrawer({ eventID }) {
  const { user } = UserAuth();
  const [searchParams, setSearchParams] = useSearchParams();
  const { openDrawer, setOpenDrawer } = Variables();
  const [loading, setLoading] = React.useState(false);
  const [tickets, setTicket] = React.useState([]);
  // const { eventID } = useParams();
  const [expanded, setExpanded] = React.useState(false);
  const [refreshCount, setRefreshCount] = React.useState(false);

  const [events, setEvents] = React.useState([]);
  const [billets, setBillets] = React.useState([]);
  const [seances, setSeances] = React.useState([]);
  const [compare, setCompare] = React.useState();
  const [nombre, setNombre] = React.useState(0);
  const [filterStatut, setFilterStatut] = React.useState([]);
  const [filterOrigine, setFilterOrigine] = React.useState([]);
  const [filterBillet, setFilterBillet] = React.useState([]);
  const [filterSeance, setFilterSeance] = React.useState([]);
  const [filterHist, setFilterHist] = React.useState('');

  const [filters, setFilters] = useState({
    filterSeances: [], filterStatus: [], filterOrigine: [], filterBillet: [], filterHist: null, start: null, end: null
  });

  const [selectedStatut, setSelectedStatut] = React.useState([]);
  const [status, setStatus] = React.useState([{ label: 'Payé', value: 1 }, { label: 'Reservé', value: 0 }]);

  const handleChangev1 = (field, value) => {
    console.log(value)
    setFilters(prev => ({ ...prev, [field]: value }));
  }


  const handleChangev2 = (field, key, value) => {
    setFilters(prev => ({
      ...prev,
      [field]: {
        ...prev[field],
        [key]: value
      }
    }));
  };

  // filtre items
  const [stateStatus, setStateStatus] = React.useState({
    paye: false,
    reserve: false,
  });

  const [origine, setOrigine] = React.useState({
    appli: false,
    ajout: false,
    siteWeb: false,
    guichet: false,
  });

  const [billet, setBillet] = React.useState();

  const handleChangeStatus = (event) => {
    const tmp = filterStatut.findIndex((element) => parseInt(element === event.target.value));
    if (event.target.checked && tmp === -1) {
      setFilterStatut((tickets) => [...tickets, parseInt(event.target.value)]);
    } else {
      const array = filterStatut;
      array.splice(tmp, 1);
      setFilterStatut(array);
    }

    setStateStatus({
      ...stateStatus,
      [event.target.name]: event.target.checked,
    });
    setRefreshCount(!refreshCount);
  };

  const handleChangeOrigine = (event) => {
    const tmp = filterOrigine.findIndex((element) => element === event.target.value);
    if (event.target.checked && tmp === -1) {
      setFilterOrigine((tickets) => [...tickets, event.target.value]);
    } else {
      const array = filterOrigine;
      array.splice(tmp, 1);
      setFilterOrigine(array);
    }

    setOrigine({
      ...origine,
      [event.target.name]: event.target.checked,
    });
    setRefreshCount(!refreshCount);
  };

  const handleChangeBillet = (event) => {
    const tmp = filterBillet.findIndex((element) => element === event.target.value);
    if (event.target.checked && tmp === -1) {
      setFilterBillet((billets) => [...billets, event.target.value]);
    } else {
      const array = filterBillet;
      array.splice(tmp, 1);
      setFilterBillet(array);
    }

    setBillet({
      ...billet,
      [event.target.name]: event.target.checked,
    });
    console.log(billet)
    setRefreshCount(!refreshCount);
  };



  const handleChange = (panel) => async (event, isExpanded) => {
    if (panel === 'panel1') {
      if (events.length === 0) {
        setEvents([]);
        console.log(user);
        const u1 = await getDoc(doc(db, 'organisateurs', `${user.uid}`));
        console.log(u1.data());
        const q = query(
          collection(db, 'evenement'),
          where('orgId', '==', u1.data().idOrg),
          orderBy('dateDebut', 'asc')
        );
        const querySnapshot = await getDocs(q);
        // setEvents(querySnapshot.docs);
        querySnapshot.forEach((doc) => {
          // sort list
          const element = doc;
          if (element.data().status === 1) {
            setEvents((events) => [...events, element]);
          }
        });
      }
    } else {
      console.log('ko');
    }
    setExpanded(isExpanded ? panel : false);
  };

  const navigate = useNavigate();

  const encodeFiltersToURL = (filters) => {
    const params = new URLSearchParams();
  
    Object.entries(filters).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach(val => params.append(key, val));
      } else if (value !== null && value !== '') {
        params.append(key, value);
      }
    });
  
    return params.toString(); // output: filterSeances=...&filterStatus=...
  };
  
  const applyFilter = () => {
    // setFilters(filters);
    const query = encodeFiltersToURL(filters);
    console.log(query)
    navigate(`/${eventID}/dashboard/participants?${query}`);
    setOpenDrawer(false);
  };

  const location = useLocation();

  const decodeURLToFilters = (searchParams) => {
    const params = new URLSearchParams(searchParams);
    const filters = {
      filterSeances: [],
      filterStatus: [],
      filterOrigine: [],
      filterBillet: [],
      filterHist: null,
      start: null,
      end: null
    };
  
    // eslint-disable-next-line no-restricted-syntax
    for (const [key, value] of params.entries()) {
      if (key in filters && Array.isArray(filters[key])) {
        filters[key].push(value);
      } else if (key === 'filterHist' || key === 'start' || key === 'end') {
        filters[key] = value;
      }
    }
  
    return filters;
  };
  
 React. useEffect(() => {
    const parsedFilters = decodeURLToFilters(location.search);
    setFilters(parsedFilters);
  }, [location.search]);

  React.useEffect(() => {
    (async () => {
      setTicket([]);
      const tmp = new Map();
      try {
        const q = query(collection(db, `evenement/${eventID}/tickets`));
        const snapshot = await getDocs(q);
        snapshot.forEach((d) => {
          setTicket((tickets) => [...tickets, d]);
          tmp.set(d.data().ticket_name, false);
        });
        setBillet(tmp);
        console.log(tmp);
        const term = searchParams.get('q');
        console.log('params: ', term);
        if (term) {
          console.log('--------------debut filtres---------------------')
          const tmpfilter = term.split('&');
          console.log(tmpfilter);
          tmpfilter.forEach((element) => {
            if (element.includes('fs')) {
              console.log('filter statut');
              const tmp = element.split('=');
              console.log(tmp);
              const tmp1 = tmp[1].split(',');
              console.log(tmp1);
              const filterStatut = [];
              tmp1.forEach((element) => {
                filterStatut.push(parseInt(element));
              });
              if (filterStatut.length !== 0) {
                /* setQueryContains((query) => [...query, where('status', 'in', filterStatut)]);
                query1.push(where('status', 'in', filterStatut)); */
              }
            }
            if (element.includes('fo')) {
              console.log('filter origine');
            }
            if (element.includes('fb')) {
              console.log('filter billet');
              const tmp1 = element.split('=');
              console.log(tmp1);
              const filterBillet = tmp1[1].split(',');
              console.log(filterBillet);
              if (filterBillet.length !== 0) {
                filterBillet.forEach(element => {
                  setBillet({
                    ...billet,
                    [element]: true,
                  });
                });
                console.log(billet);
                console.log(tmp);

                /* setQueryContains((query) => [...query, where('refTicket', 'in', filterBillet)]);
                query1.push(where('refTicket', 'in', filterBillet)); */
              }
            }
            if (element.includes('fa')) {
              const today = new Date();
              const date = new Date(today.getFullYear(), today.getMonth(), today.getDate());
              const ttmp = new Date(today.getTime() + 24 * 60 * 60 * 1000);
              const tomorrow = new Date(ttmp.getFullYear(), ttmp.getMonth(), ttmp.getDate());
              const tmp = element.split('=');
              const filterHist = tmp[1];
              setFilterHist(filterHist);
            }
          });
          console.log('--------------fin filtres---------------------')
        }
      } catch (error) {
        console.log('error');
      }
    })();
  }, []);

  return (
    <Box>
      <Box paddingBottom={3} paddingX={3} sx={{ height: { xs: '75vh', sm: ' 78vh', xl: '85vh' }, overflowX: 'auto', overflowY: 'auto' }}>
        <Typography variant="subtitle1" paddingBottom={1} paddingTop={3}>
          Commandes
        </Typography>
        <Accordion
          expanded={expanded === 'panel5'}
          onChange={handleChange('panel5')}
          sx={{ bgcolor: '#F0F0F0', mb: 2 }}
        >
          <AccordionSummary
            expandIcon={
              expanded !== 'panel5' && filterStatut.length !== 0 ? (
                <Badge color="secondary" badgeContent={filterStatut.length}>
                  <Iconify icon={'ep:arrow-down-bold'} />
                </Badge>
              ) : (
                <Iconify icon={'ep:arrow-down-bold'} />
              )
            }
            aria-controls="panel5bh-content"
            id="panel5bh-header"
          >
            <Stack spacing={1} direction="row" alignItems="center">
              <Iconify icon="mdi:calendar-outline" sx={{ width: 20, height: 20 }} />
              <Typography>Seance</Typography>
            </Stack>
          </AccordionSummary>
          <AccordionDetails>
            <FormControl component="fieldset">
              <FormLabel component="legend"><Typography variant='caption'>A quelle Seance appartient cette commande</Typography></FormLabel>
              <FormGroup aria-label="position">
                <FormControlLabel
                  key={'paye'}
                  value={1}
                  control={<Checkbox checked={stateStatus.paye} onChange={handleChangeStatus} name="paye" />}
                  label={'Payé'}
                  labelPlacement="end"
                />
                <FormControlLabel
                  key={'reserve'}
                  value={0}
                  control={<Checkbox checked={stateStatus.reserve} onChange={handleChangeStatus} name="reserve" />}
                  label={'Reservé'}
                  labelPlacement="end"
                />
              </FormGroup>
            </FormControl>
          </AccordionDetails>
        </Accordion>

        <Accordion
          expanded={expanded === 'panel3'}
          onChange={handleChange('panel3')}
          sx={{ bgcolor: '#f2f2f2', mb: 2 }}
        >
          <AccordionSummary
            expandIcon={<Iconify icon={'ep:arrow-down-bold'} />}
            aria-controls="panel2bh-content"
            id="panel2bh-header"
          >
            <Stack spacing={1} direction="row" alignItems="center">
              <Iconify icon="material-symbols-light:interests-outline" sx={{ minWidth: 20, minHeight: 20 }} />
              <Typography>Statut</Typography>
              {(filters.filterStatus.length > 0) && (
                <Stack spacing={1} direction="row" justifyContent="space-between" alignItems="center">
                  <Typography sx={{ color: '#5E17EB' }} variant="caption">
                    {filters.filterStatus.length === 1 ? filters.filterStatus[0] : filters.filterStatus.length > 1 ? `${filters.filterStatus[0]}  + ${filters.filterStatus.length - 1}` : null}
                  </Typography>
                  <IconButton onClick={(e) => {
                    setSelectedStatut([])
                    handleChangev1('filterStatus', [])
                    e.stopPropagation()
                  }}>
                    <Iconify icon="typcn:delete" sx={{ width: 15, height: 15 }} />
                  </IconButton>
                </Stack>
              )}
            </Stack>
          </AccordionSummary>
          <AccordionDetails>
            <Typography variant="caption">Filtrer vos commandes en fonction de leur statut.</Typography>
            <Box padding={1}>
              <Autocomplete
                multiple
                id="tags-standard"
                options={status}
                getOptionLabel={(state) => state?.label}
                value={selectedStatut}
                onChange={(event, newValue) => {
                  console.log(newValue)
                  setSelectedStatut(newValue)
                  setFilters((prevFilters) => ({
                    ...prevFilters,
                    filterStatus: newValue.map((state) => state.label) // Mettre à jour les intérêts sélectionnés
                  }));
                  console.log(filters)
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    placeholder={filters.filterStatus.length > 0 ? null : 'Selectionner les status'}
                    // error={!!error}
                    multiline
                  // helperText={error}
                  />
                )}
                renderTags={(tagValue, getTagProps) =>
                  tagValue.map((state, index) => (
                    <Chip
                      sx={{ bgcolor: '#F5EFFA' }}
                      key={state.value}
                      label={state.label}
                      {...getTagProps({ index })}
                    />
                  ))
                }
              />
            </Box>
          </AccordionDetails>
        </Accordion>

        <Accordion
          expanded={expanded === 'panel2'}
          onChange={handleChange('panel2')}
          sx={{ bgcolor: '#F0F0F0', mb: 2 }}
        >
          <AccordionSummary
            expandIcon={
              expanded !== 'panel2' && filterOrigine.length !== 0 ? (
                <Badge color="secondary" badgeContent={filterOrigine.length}>
                  <Iconify icon={'ep:arrow-down-bold'} />
                </Badge>
              ) : (
                <Iconify icon={'ep:arrow-down-bold'} />
              )
            }
            aria-controls="panel2bh-content"
            id="panel2bh-header"
          >
            <Stack spacing={1} direction="row" alignItems="center">
              <Iconify icon="ion:share-social-outline" sx={{ width: 20, height: 20 }} />
              <Typography>Origine</Typography>
            </Stack>
          </AccordionSummary>
          <AccordionDetails>
            <FormControl component="fieldset">
              <FormLabel component="legend">Contacts qui ont participé à au moins un des évènements suivants</FormLabel>
              <FormGroup aria-label="position">
                <FormControlLabel
                  key={'appli'}
                  value={1}
                  control={<Checkbox checked={origine.appli} onChange={handleChangeOrigine} name="appli" />}
                  label={'Application'}
                  labelPlacement="end"
                />
                <FormControlLabel
                  key={'ajout'}
                  value={0}
                  control={<Checkbox checked={origine.ajout} onChange={handleChangeOrigine} name="ajout" />}
                  label={'Ajout Manuel'}
                  labelPlacement="end"
                />
                <FormControlLabel
                  key={'reserve'}
                  value={0}
                  control={<Checkbox checked={origine.siteWeb} onChange={handleChangeOrigine} name="siteWeb" />}
                  label={'Site Web'}
                  labelPlacement="end"
                />
                <FormControlLabel
                  key={'guichet'}
                  value={0}
                  control={<Checkbox checked={origine.guichet} onChange={handleChangeOrigine} name="guichet" />}
                  label={'Guichet'}
                  labelPlacement="end"
                />
              </FormGroup>
            </FormControl>
          </AccordionDetails>
        </Accordion>
        <Typography variant="subtitle1" paddingBottom={1} paddingTop={3}>
          Billets
        </Typography>
        <Accordion
          expanded={expanded === 'panel4'}
          onChange={handleChange('panel4')}
          sx={{ bgcolor: '#F0F0F0', mb: 2 }}
        >
          <AccordionSummary
            expandIcon={
              expanded !== 'panel4' && filterBillet.length !== 0 ? (
                <Badge color="secondary" badgeContent={filterBillet.length}>
                  <Iconify icon={'ep:arrow-down-bold'} />
                </Badge>
              ) : (
                <Iconify icon={'ep:arrow-down-bold'} />
              )
            }
            aria-controls="panel3bh-content"
            id="panel3bh-header"
          >
            <Stack spacing={1} direction="row" alignItems="center">
              <Iconify icon="ph:gender-neuter-thin" sx={{ width: 20, height: 20 }} />
              <Typography>Type de tarifs</Typography>
            </Stack>
          </AccordionSummary>
          <AccordionDetails>
            <FormControl component="fieldset">
              <FormLabel component="legend">Contacts qui ont participé à au moins un des évènements suivants</FormLabel>
              <FormGroup aria-label="position">
                {tickets.map((ticket, index) => (
                  <FormControlLabel
                    key={ticket.id}
                    value={ticket.id}
                    control={
                      <Checkbox
                        checked={billet[ticket.data().ticket_name]}
                        onChange={handleChangeBillet}
                        name={ticket.id}
                      />
                    }
                    label={ticket.data().ticket_name}
                    labelPlacement="end"
                  />
                ))}
              </FormGroup>
            </FormControl>
          </AccordionDetails>
        </Accordion>

        <Typography variant="subtitle1" paddingBottom={1} paddingTop={3}>
          Historique
        </Typography>
        {/** Historique d'ajout */}
        <Accordion
          expanded={expanded === 'panel10'}
          onChange={handleChange('panel10')}
          sx={{ bgcolor: '#F0F0F0', mb: 2 }}
        >
          <AccordionSummary
            expandIcon={<Iconify icon={'ep:arrow-down-bold'} />}
            aria-controls="panel4bh-content"
            id="panel4bh-header"
          >
            <Stack spacing={1} direction="row" alignItems="center">
              <Iconify icon="material-symbols-light:history" sx={{ width: 20, height: 20 }} />
              <Typography>Date d'ajout</Typography>
              {(filters?.filterHist !== null) && (
                <Stack spacing={1} direction="row" justifyContent="space-between" alignItems="center">
                  <Typography sx={{ color: '#5E17EB' }} variant="caption">
                    {filters?.filterHist === 'custom' && filters?.start && filters?.end ? `${filters?.start} - ${filters?.end}` : filters?.filterHist === 'today' ? 'Aujourd\'hui' : filters?.filterHist === 'yesterday' ? 'Hier' : filters?.filterHist === 'last-7-days' ? 'Derniers 7 jours' : filters?.filterHist === 'last-14-days' ? 'Derniers 14 jours' : filters?.filterHist === 'last-30-days' ? 'Derniers 30 jours' : null}
                  </Typography>
                  <IconButton onClick={(e) => {
                    handleChangev1('filterHist', null)
                    e.stopPropagation()
                  }}>
                    <Iconify icon="typcn:delete" sx={{ width: 15, height: 15 }} />
                  </IconButton>
                </Stack>
              )}
            </Stack>
          </AccordionSummary>
          <AccordionDetails>
            <FormControl>
              <FormLabel id="demo-radio-buttons-group-label1">
                Quand ce contact a été ajouté à votre communauté
              </FormLabel>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label1"
                defaultValue="female"
                name="radio-buttons-group1"
                value={filters?.filterHist}
                onChange={(e) => handleChangev1('filterHist', e.target.value)}
              >
                <FormControlLabel value="today" control={<Radio />} label="Aujourd'hui" />
                <FormControlLabel value="yesterday" control={<Radio />} label="Hier" />
                <FormControlLabel value="last-7-days" control={<Radio />} label="Derniers 7 jours" />
                <FormControlLabel value="last-14-days" control={<Radio />} label="Derniers 14 jours" />
                <FormControlLabel value="last-30-days" control={<Radio />} label="Derniers 30 jours" />
                <FormControlLabel value="custom" control={<Radio />} label="Selectionner la plage" />
              </RadioGroup>
            </FormControl>
            {
              filters?.filterHist === 'custom' && <Stack paddingY={1} spacing={1} direction="column">
                <Typography variant="body2">Debut</Typography>
                <TextField type='date' value={filters?.start} onChange={(e) => handleChangev1('start', e.target.value)} size="small" />
                <Typography variant="body2">Fin</Typography>
                <TextField type='date' value={filters?.end} onChange={(e) => handleChangev1('end', e.target.value)} size="small" />
              </Stack>
            }

          </AccordionDetails>
        </Accordion>
      </Box>
      <Stack direction='column' spacing={1} padding={1} justifyContent={'right'} alignItems={'end'} sx={{ borderTop: '1px solid gainsboro' }}>
        <Typography variant='body2'><strong>{nombre}</strong> commandes</Typography>
        <Stack direction='row' spacing={2}>
          <CustomButton loading={loading} type={'secondaire'} buttonText={'Annuler'} onClick={() => {
            setOpenDrawer(false);
          }} />
          <CustomButton loading={loading} type={'primaire'} buttonText='Afficher les contacts' onClick={applyFilter} />
        </Stack>

      </Stack>
    </Box>
  );
}
